import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from './Navbar';
import ContentItem from './ContentItem';
import dummyData from '../dummyData';
import './TagResultsPage.css'; // We'll create this CSS file

function TagResultsPage() {
  const { tagName } = useParams(); // Get tagName from URL parameter
  const [taggedItems, setTaggedItems] = useState([]);

  useEffect(() => {
    if (tagName) {
      const decodedTagName = decodeURIComponent(tagName);
      const allItems = Object.entries(dummyData).flatMap(([category, items]) => 
        items.map(item => ({ ...item, category }))
      );
      
      const filteredResults = allItems.filter(item => 
        item.tags && item.tags.some(tag => tag.toLowerCase() === decodedTagName.toLowerCase())
      );
      setTaggedItems(filteredResults);
    } else {
      setTaggedItems([]);
    }
  }, [tagName]);

  return (
    <div>
      <Navbar />
      <div className="tag-results-page">
        <h1>标签： "{decodeURIComponent(tagName) || ''}"</h1>
        {tagName && taggedItems.length > 0 && (
          <p className="results-count">找到了 {taggedItems.length} 条与此标签相关的内容。</p>
        )}
        <div className="results-list">
          {tagName ? (
            taggedItems.length > 0 ? (
              taggedItems.map(item => (
                <ContentItem key={`${item.category}-${item.id}`} item={item} />
              ))
            ) : (
              <p>抱歉，没有找到与标签 "{decodeURIComponent(tagName)}" 相关的内容。</p>
            )
          ) : (
            <p>无效的标签。</p> // Should not happen if navigated correctly
          )}
        </div>
        <div className="navigation-links">
          <Link to="/" className="back-link">返回首页</Link>
          <Link to="/categories" className="back-link">查看所有分类</Link>
        </div>
      </div>
    </div>
  );
}

export default TagResultsPage;
